export default class ButtonResult extends Phaser.Group {
  constructor({ game, x = 0, y = 0, dx = 0, dy = 0, id, bmd, atlas = 'ui_buttons' }) {
    super(game, x, y, atlas);

    this.characterId = id;

    this.onTap = new Phaser.Signal();

    this.bg = this.game.make.image(0, 5, atlas, 'btn_rating_bg');
    this.bg.anchor.set(0.5);
    this.bg.inputEnabled = true;
    this.bg.input.useHandCursor = true;
    this.bg.events.onInputDown.add(this.handleInputDown, this);
    this.bg.events.onInputOver.add(this.handleInputOver, this);
    this.bg.events.onInputOut.add(this.handleInputOut, this);
    this.addChild(this.bg);

    const rect = this.bg.getLocalBounds();
    rect.y -= 120;
    rect.height += 120;

    this.bg.hitArea = rect;

    //
    // const sc = 0.6;
    // this.image = this.game.make.image(-dx * sc, -dy * sc, bmd);
    // this.image.anchor.set(0.5);
    //
    // const x0 = 90 - (this.image.width * sc) / 2;
    // const x1 = -90 + (this.image.width * sc) / 2;
    // this.image.x = Phaser.Math.clamp(this.image.x, x0, x1);
    // const y0 = 90 - (this.image.height * sc) / 2;
    // const y1 = -90 + (this.image.height * sc) / 2;
    // this.image.y = Phaser.Math.clamp(this.image.y, y0, y1);
    //
    // this.image.scale.set(sc);
    // this.image.inputEnabled = false;
    // this.addChild(this.image);
    //
    // //
    // this.imageMask = this.game.make.graphics();
    // this.imageMask.beginFill(0xff0000);
    // this.imageMask.drawCircle(0, 0, 180);
    // this.addChild(this.imageMask);
    //
    // this.image.mask = this.imageMask;

    this.image = this.game.make.image(0, 0, this.getMaskedTexture(dx, dy, bmd));
    this.image.anchor.set(0.5);
    this.image.inputEnabled = false;
    this.addChild(this.image);

    this.border = this.game.make.image(0, 5, atlas, 'btn_rating_frame');
    this.border.anchor.set(0.5);
    this.addChild(this.border);
  }

  getMaskedTexture(dx, dy, bmd) {
    const r = 90;
    const sc = 0.6;

    const image = this.game.make.image(-dx * sc, -dy * sc, bmd);
    image.anchor.set(0.5);

    const x0 = r - (image.width * sc) / 2;
    const x1 = -r + (image.width * sc) / 2;
    image.x = Phaser.Math.clamp(image.x, x0, x1);
    const y0 = r - (image.height * sc) / 2;
    const y1 = -r + (image.height * sc) / 2;
    image.y = Phaser.Math.clamp(image.y, y0, y1);

    image.scale.set(sc);

    image.x += r;
    image.y += r;

    //
    const vectorMask = this.game.make.graphics();
    vectorMask.beginFill(0xff0000);
    vectorMask.drawCircle(0, 0, r * 2);

    const imageMask = this.game.make.image(0, 0, vectorMask.generateTexture());
    const w = imageMask.width;
    const h = imageMask.height;
    const bmdMask = this.game.make.bitmapData(w, h);
    bmdMask.alphaMask(image, imageMask);

    return bmdMask;
  }

  enable() {
    this.bg.input.enabled = true;
  }

  disable() {
    this.bg.input.enabled = false;
  }

  onDown() {
    this.game.sounds.playVO(this.voId, {
      spriteID: 'vo_ui',
    });
  }

  handleInputDown() {
    this.onTap.dispatch(this);
  }

  handleInputOver() {
    this.scaleBeforeOver = this.bg.scale.x;
    const scale = this.bg.scale.x === 1.2 ? 1.2 : this.bg.scale.x * 1.1;
    this.bg.scale.set(scale);
    this.image.scale.set(scale);
    this.border.scale.set(scale);
    this.stars.scale.set(scale);
  }

  handleInputOut() {
    const scale = this.scaleBeforeOver;
    this.bg.scale.set(scale);
    this.image.scale.set(scale);
    this.border.scale.set(scale);
    this.stars.scale.set(scale);
  }

  destroy() {
    this.bg.events.onInputDown.removeAll();
    this.disable();
    super.destroy();
  }

  makeBigger() {
    this.game.add.tween(this.bg.scale).to({ x: 1.2, y: 1.2 }, 350, Phaser.Easing.Back.Out, true);
    this.game.add.tween(this.image.scale).to({ x: 1.2, y: 1.2 }, 350, Phaser.Easing.Back.Out, true);
    this.game.add
      .tween(this.border.scale)
      .to({ x: 1.2, y: 1.2 }, 350, Phaser.Easing.Back.Out, true);
    this.game.add.tween(this.stars.scale).to({ x: 1.2, y: 1.2 }, 350, Phaser.Easing.Back.Out, true);
  }

  makeNormal() {
    this.game.add.tween(this.bg.scale).to({ x: 1, y: 1 }, 350, Phaser.Easing.Back.In, true);
    this.game.add.tween(this.image.scale).to({ x: 1, y: 1 }, 350, Phaser.Easing.Back.In, true);
    this.game.add.tween(this.border.scale).to({ x: 1, y: 1 }, 350, Phaser.Easing.Back.In, true);
    this.game.add.tween(this.stars.scale).to({ x: 1, y: 1 }, 350, Phaser.Easing.Back.In, true);
  }

  makeSmaller() {
    this.game.add.tween(this.bg.scale).to({ x: 0.9, y: 0.9 }, 350, Phaser.Easing.Back.Out, true);
    this.game.add.tween(this.image.scale).to({ x: 0.9, y: 0.9 }, 350, Phaser.Easing.Back.Out, true);
    this.game.add
      .tween(this.border.scale)
      .to({ x: 0.9, y: 0.9 }, 350, Phaser.Easing.Back.Out, true);
    this.game.add.tween(this.stars.scale).to({ x: 0.9, y: 0.9 }, 350, Phaser.Easing.Back.Out, true);
  }
}
